// extracted by mini-css-extract-plugin
export default {"author":"Item_author__mKoSh","content":"Item_content__UQjQQ","date":"Item_date__Hl6eb","text":"Item_text__UIkXH","user":"Item_user__srxjN"};